/**
 * Created by neo on 21.06.17.
 */

import { makeAutoObservable } from 'mobx';
import { WorkoutLog } from './WorkoutLog';

export type WorkoutLogAnalytics = {
  workoutLog?: WorkoutLog;
  readonly totalCaloriesBurnt: number;
  readonly totalSets: number;
  readonly totalTimeExercising: number;
  readonly totalRestTime: number;
  readonly totalKg: number;
  readonly totalRepetitions: number;
};

export function createWorkoutLogAnalytics(workoutLog?: WorkoutLog): WorkoutLogAnalytics {
  return makeAutoObservable({
    workoutLog,

    get totalCaloriesBurnt(): number {
      return this.workoutLog?.totalCaloriesBurnt ?? 0;
    },

    get totalSets(): number {
      return this.workoutLog?.totalSets ?? 0;
    },

    get totalTimeExercising(): number {
      return this.workoutLog?.totalDuration ?? 0;
    },

    get totalRestTime(): number {
      return this.workoutLog?.breakTime ?? 0;
    },

    get totalKg(): number {
      return this.workoutLog?.totalOf('WEIGHT') ?? 0;
    },

    get totalRepetitions(): number {
      return this.workoutLog?.totalOf('REPETITIONS') ?? 0;
    },
  });
}
